import { Container } from '@cleartrip/ct-design-components'

import ImageBlock from '@/components/imageBlock'
import { getFlightLogoUrl, shouldShowAirlineLogoBorder } from '@/utils/images'

import MultiAirlineIcon from './MultiAirlineIcon'
import type { TupleAirline } from '../model/types'

export interface AirlineLogosProps {
  airlines: TupleAirline[]
  size: number
}

const uniqueAirlines = (airlines: TupleAirline[]): TupleAirline[] => {
  const seen = new Set<string>()
  return airlines.filter(airline => {
    if (seen.has(airline.code)) return false
    seen.add(airline.code)
    return true
  })
}

const AirlineLogo: React.FC<{ code: string; size: number }> = ({ code, size }) => (
  <ImageBlock
    isCircleLogo
    altText={code}
    customClass='br-50p o-hidden'
    height={size}
    path={getFlightLogoUrl(code, 'circle_logo')}
    showBorder={shouldShowAirlineLogoBorder(code)}
    width={size}
  />
)

const AirlineLogos: React.FC<AirlineLogosProps> = ({ airlines, size }) => {
  const unique = uniqueAirlines(airlines)
  if (unique.length === 0) return null

  if (unique.length >= 3) {
    return (
      <Container className='flex-no-shrink' css={{ height: size, width: size }}>
        <MultiAirlineIcon size={size} />
      </Container>
    )
  }

  if (unique.length === 2) {
    const offset = Math.round(size * 0.35)
    const stackSize = size + offset

    return (
      <Container className='flex-no-shrink p-relative' css={{ height: stackSize, width: stackSize }}>
        <Container className='p-absolute' css={{ left: 0, top: 0, zIndex: 1, height: size, width: size }}>
          <AirlineLogo code={unique[0].code} size={size} />
        </Container>
        <Container
          className='p-absolute br-50p o-hidden'
          css={{
            height: size,
            left: offset,
            top: offset,
            width: size,
            zIndex: 2,
          }}
        >
          <AirlineLogo code={unique[1].code} size={size} />
        </Container>
      </Container>
    )
  }

  return (
    <Container className='flex-no-shrink' css={{ height: size, width: size }}>
      <AirlineLogo code={unique[0].code} size={size} />
    </Container>
  )
}

export default AirlineLogos
